import React from 'react';

const BriefCaseIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.9974 10.0003H10.0057M13.3307 5.00033V3.33366C13.3307 2.89163 13.1551 2.46771 12.8426 2.15515C12.53 1.84259 12.1061 1.66699 11.6641 1.66699H8.33073C7.8887 1.66699 7.46478 1.84259 7.15222 2.15515C6.83966 2.46771 6.66406 2.89163 6.66406 3.33366V5.00033M18.3307 10.8337C15.8581 12.4661 12.9604 13.3364 9.9974 13.3364C7.03444 13.3364 4.13674 12.4661 1.66406 10.8337M3.33073 5.00033H16.6641C17.5845 5.00033 18.3307 5.74652 18.3307 6.66699V15.0003C18.3307 15.9208 17.5845 16.667 16.6641 16.667H3.33073C2.41025 16.667 1.66406 15.9208 1.66406 15.0003V6.66699C1.66406 5.74652 2.41025 5.00033 3.33073 5.00033Z'
        stroke='#6B7280'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default BriefCaseIcon;
